// функции всплывающих сообщений

  const showType = {info:'Информация', danger:'Внимание'};

  function showAlert(message, type = "") {
    // Удалить предыдущий алерт, если есть
    killAlert();

    var shownType = "";
  
    // Создать элемент алерта
    const alert = document.createElement('article');
    if (type == "") {
      alert.className = 'alert info-panel';
    } else {
      alert.className = `alert alert-${type}`;
      shownType = showType[type];
    }
    alert.style.display = 'block';
    alert.innerHTML = `
        <strong>${shownType}:&nbsp</strong>${message}
        <span class="close" onclick="this.parentElement.remove()">&times;</span>
    `;
  
    // Добавить алерт в body
    document.body.appendChild(alert);
  
    // Автоматически скрыть через 5 секунды
    setTimeout(() => {
        if (alert.parentElement) {
            alert.style.opacity = '0';
            setTimeout(() => alert.remove(), 500);
        }
    }, 5000);
  }
  
  function showBusyAlert(message, start = 5) {
    // Удалить предыдущий алерт, если есть
    killAlert();
    
    // Создать элемент алерта
    const alert = document.createElement('span');
    alert.className = `alert info-panel`;
    alert.style.display = 'block';
    alert.data = start;
    alert.innerHTML = `<span style="display: flex;align-items: center;"><span class="loader"></span><span style="padding-left: 15px;">${message}</span></span>`;
    
    // Добавить алерт в body
    document.body.appendChild(alert);
    
    return alert;
  }
  
  function addAlert(message){
    const oldAlert=document.querySelector('.alert');
    if(oldAlert) oldAlert.innerHTML += `<div style="padding-top: 15px;">${message}</div >`;
  }
  
  function fackeProgess(alert, message) {
    const progressInterval = setInterval(() => {
      alert.data = (+alert.data || 0) + 5; // Унарный + для преобразования
      const span = alert.querySelector('span');
      span.textContent = `${message} ${alert.data}%`;
      
      if (alert.data >= 90) clearInterval(progressInterval);
    }, 300);
    return progressInterval;
  }
  
  function closeAlert(alert, wtite = 2500) { 
    setTimeout(() => alert.remove(), wtite); 
  }
  
  function killAlert(white = 0) { 
    const oldAlert = document.querySelector('.alert'); 
    if (oldAlert) (white>0) ? closeAlert(oldAlert,white) : oldAlert.remove(); 
  }
  
  /* как пользовать вопрос к юзеру
  const result = await showConfirm("Вы действительно хотите выйти?");
  if (result) {
      alert("Вы выбрали ДА!");
  } else {
      alert("Вы выбрали НЕТ!");
  }
  */
  async function showConfirm(message) {
    // Создаем диалог если его нет
    let dialog = document.getElementById('dynamicConfirmDialog');
    
    if (!dialog) {
        dialog = document.createElement('dialog');
        dialog.id = 'dynamicConfirmDialog';
        dialog.innerHTML = `
          <article class="confirm-dialog">
              <h4>Подтвердите действие</h4>
                <p id="dynamicConfirmMessage">${message}</p>
              <footer>
                <form method="dialog">
                  <button value="yes">Да</button>
                  <button class="secondary" value="no">Нет</button>
                </form>
              </footer>
          </article>
        `;
        document.body.appendChild(dialog);
    } else {
        document.getElementById('dynamicConfirmMessage').textContent = message;
    }
    
    dialog.showModal();
    
    return new Promise((resolve) => {
        dialog.addEventListener('close', function handler() {
            dialog.removeEventListener('close', handler);
            resolve(dialog.returnValue === 'yes');
        });
    });
  }

  if (typeof window !== 'undefined') {
    window.showAlert = showAlert;
    window.showBusyAlert = showBusyAlert;
    window.addAlert = addAlert;
    window.fackeProgess = fackeProgess;
    window.closeAlert = closeAlert;
    window.killAlert = killAlert;
    window.showConfirm = showConfirm;
  }